<template>
  <div
    v-if="visible"
    class="contractRenewOverlay"
    @click.self="handleClose"
  >
    <div class="contractRenewCard" role="dialog" aria-modal="true">
      <div class="contractRenewBody">
        <div class="contractRenewIconWrap">
          <i class="el-icon-document contractRenewIcon"></i>
        </div>
        <h3 class="contractRenewTitle">合同续签提示</h3>
        <p class="contractRenewDesc">
          请及时联系您的良信专员进行线下续签合同
        </p>

        <div class="contractRenewContactBox">
          <div class="contractRenewContactRow">
            <i class="el-icon-user contractRenewContactIcon"></i>
            <span>授权专员：{{ specialistName }}</span>
          </div>
          <div class="contractRenewContactRow">
            <i class="el-icon-phone contractRenewContactIcon"></i>
            <span>联系电话：{{ specialistPhone }}</span>
          </div>
        </div>

        <div class="contractRenewWarn">
          <i class="el-icon-warning contractRenewWarnIcon"></i>
          <div class="contractRenewWarnContent">
            <p class="contractRenewWarnTitle">温馨提示</p>
            <p class="contractRenewWarnText">{{ warnText }}</p>
          </div>
        </div>

        <div class="contractRenewActions">
          <button
            type="button"
            class="contractRenewBtn contractRenewBtn--ghost"
            @click="handleClose"
          >
            知道了
          </button>
          <button
            type="button"
            class="contractRenewBtn contractRenewBtn--primary"
            @click="copySpecialistPhone"
          >
            <i class="el-icon-phone"></i>
            <span>联系授权专员</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 合同续签提示弹窗
 * 对应设计稿：code.html 续签弹窗
 */
export default {
  name: "ContractRenewModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** 授权专员姓名 */
    specialistName: {
      type: String,
      default: "张明",
    },
    /** 授权专员联系电话（展示用，可含横线） */
    specialistPhone: {
      type: String,
      default: "138-8888-888",
    },
    /** 温馨提示正文 */
    warnText: {
      type: String,
      default:
        "为了不影响您的正常使用，请尽快联系授权专员完成续签手续。合同到期后，您的授权权益将会暂时失效",
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    /** 复制授权专员联系电话 */
    async copySpecialistPhone() {
      const phone = String(this.specialistPhone || "").trim();
      if (!phone) {
        this.$message.warning("暂无联系电话");
        return;
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(phone);
        } else {
          this.fallbackCopyText(phone);
        }
        this.$message.success("电话号码已复制");
        this.$emit("copy-phone", phone);
      } catch (e) {
        try {
          this.fallbackCopyText(phone);
          this.$message.success("电话号码已复制");
          this.$emit("copy-phone", phone);
        } catch (err) {
          this.$message.error("复制失败，请手动复制");
        }
      }
    },
    /** 兼容不支持 Clipboard API 的环境 */
    fallbackCopyText(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "readonly");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(textarea);
      if (!ok) throw new Error("execCommand copy failed");
    },
  },
};
</script>

<style lang="less" scoped>
.contractRenewOverlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
}
.contractRenewCard {
  width: 100%;
  max-width: 440px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.contractRenewBody {
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contractRenewIconWrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #e6f9f8;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.contractRenewIcon {
  font-size: 32px;
  color: #00c2b8;
}
.contractRenewTitle {
  margin: 0 0 24px;
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  text-align: center;
}
.contractRenewDesc {
  margin: 0 0 24px;
  padding: 0 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #6b7280;
  text-align: center;
}
.contractRenewContactBox {
  width: 100%;
  background: #f2fafd;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
}
.contractRenewContactRow {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #374151;
  & + & {
    margin-top: 12px;
  }
}
.contractRenewContactIcon {
  font-size: 20px;
  color: #9ca3af;
}
.contractRenewWarn {
  width: 100%;
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #fffcf0;
  border-radius: 12px;
  margin-bottom: 32px;
}
.contractRenewWarnIcon {
  flex-shrink: 0;
  font-size: 20px;
  color: #faad14;
  margin-top: 2px;
}
.contractRenewWarnTitle {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 700;
  color: #1f2937;
}
.contractRenewWarnText {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #4b5563;
}
.contractRenewActions {
  display: flex;
  gap: 16px;
  width: 100%;
}
.contractRenewBtn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;
  &--ghost {
    appearance: none;
    border: 1px solid #e5e7eb;
    background: #fff;
    color: #4b5563;
    &:hover {
      background: #f9fafb;
    }
  }
  &--primary {
    appearance: none;
    border: 0;
    background: #00c2b8;
    color: #fff;
    &:hover {
      background: #00b0a7;
      color: #fff;
    }
  }
}
</style>
